import Vue from "vue";
import ApiService from "../../../../../services/api";
import moment from "moment";
import { mapGetters } from "vuex";
import helpers from "../../../../../shared/fleetbox-helpers";

export default {
	props: {
		filters: Array,
		reportName: String
	},
	data: function() {
		return {
			diagnosticChartTitle: "Confronto periodo attuale vs precedente",
			diagnosticChartSeries: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#ffdf00",
					labels: {
						visible: true,
						template: this.getStackTimeFromString,
						background: "none",
						font: "10px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#ff8300",
					labels: {
						visible: true,
						template: this.getStackTimeFromString,
						background: "none",
						font: "10px montserrat-light"
					}
				}
			],
			diagnosticChartData: [],
			diagnosticChartCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			diagnosticChartTooltip: {
				visible: true,
				template: this.getTooltip
			},
			diagnosticChatrtValueAxis: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					labels: {
						//content: this.getTimeFromString,
						visible: false
					}
				}
			],

			diagnosticChartIndex: 0,

			//MODAL CHART
			diagnosticModalShow: false,
			diagnosticChartTitle: "CONFRONTO PERIODO ATTUALE VS. PRECEDENTE",
			diagnosticChartModalIndex: 0,

			diagnosticChartPdfOptions: {
				landscape: true,
				fileName: "diagnostica",
				title: "DIAGNOSTICA"
			},

			diagnosticChartValueAxisModal: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "NR",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						//content: this.getTimeFromString,
						visible: true,
						font: "13px montserrat-light"
					}
				}
			],

			diagnosticChartLegend: {
				position: "bottom",
				item: {
					visual: function(e) {
						var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
						var layout = new kendo.drawing.Layout(rect, {
							spacing: 5,
							alignItems: "center"
						});

						var color = e.series.color; //e.options.markers.background;
						var labelColor = e.options.labels.color;

						var marker = new kendo.drawing.Path({
							fill: {
								color: color
							},
							stroke: {
								color: color
							}
						})
							.moveTo(0, 0)
							.lineTo(0, 10)
							.lineTo(30, 10)
							.lineTo(30, 0)
							.close();

						var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
							fill: {
								color: labelColor
							},
							font: "12px 'Montserrat Light', montserrat-light !important"
						});

						var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
						var rectangle = new kendo.drawing.Rect(rectGeom, {
							fill: { color: "none" },
							stroke: { color: "none" }
						});

						layout.append(marker, label, rectangle);
						layout.reflow();

						return layout;
					}
				}
			},
			vehicleIdFilterField: "number_plate",
			vehicleIdFilterFieldFormatted: "vehicles"
		};
	},
	created() {
		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "vehicles";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldFormatted = "vehicleCodes";
		}
	},
	mounted() {
		this.getData();
	},
	watch: {
		// filters: {
		// 	handler: function() {
		// 		this.getData();
		// 	},
		// 	deep: true
		// }
	},
	methods: {
		applyReportFilter() {
			this.getData();
		},
		modalChartClickHandler() {
			var self = this;

			self.diagnosticModalShow = true;
			setTimeout(() => {
				self.diagnosticChartModalIndex++;
			}, 200);
		},
		getStackTimeFromString(e) {
			return kendo.toString(e.stackValue, "n0");
		},
		getTooltip(e) {
			if (e.series.field == "current") {
				return `<span>${e.dataItem.name} - ${e.series.name} dal ${e.dataItem.from} al ${e.dataItem.to}: ${e.dataItem.current}</span>`;
			} else {
				return `<span>${e.dataItem.name} - ${e.series.name} dal ${e.dataItem.previousfrom} al ${e.dataItem.previousto}: ${e.dataItem.previous}</span>`;
			}
		},
		getData: function() {
			var self = this;

			this.$emit("on-loading", true);

			var data = this.getRequestData();

			ApiService.getDiagnosticReportChartData(data).then(res => {
				var currentData = res;

				var timesFilter = self.filters.find(item => {
					return item.id == "timerange";
				});

				var startDate = moment(timesFilter.value.startRange);
				var endDate = moment(timesFilter.value.endRange);
				var diffDay = endDate.diff(startDate, "days") + 1;

				var newStartDate = moment(startDate).add(-diffDay, "days");
				var newEndDate = moment(newStartDate)
					.add(diffDay, "days")
					.add(-1, "minutes");

				data["dateRange.From"] = moment(newStartDate)
					.utc()
					.format();
				data["dateRange.To"] = moment(newEndDate)
					.utc()
					.format();

				//adapt filter division to diagnosis summary request data["division"] --> data["division[0]"]
				if (data.division) {
					if (data.division > 0) {
						console.log("cambiata divisione per summary");
						let divisionToFilter = data.division;
						data["divisionId[0]"] = divisionToFilter;
					}

					delete data.division;
				}

				ApiService.getDiagnosticSummaryData(data).then(res => {
					var currentFromDate = self.$options.filters.dateToString(startDate);
					var currentEndDate = self.$options.filters.dateToString(endDate);

					var previousFromDate = self.$options.filters.dateToString(newStartDate);
					var previousEndDate = self.$options.filters.dateToString(newEndDate);
					self.setDiagnosticData(currentData, currentFromDate, currentEndDate, res, previousFromDate, previousEndDate);

					self.$emit("on-loading", false);
				});
			});
		},
		getTypeOfElementsString() {
			var strAnomaly = "anomalie";
			var strInfo = "informazioni";
			var filter = this.filters.find(item => {
				return item.id == "diagnosis-type";
			});
			if (filter.value.anomaly && filter.value.information) {
				return `${strAnomaly} e ${strInfo}`;
			} else if (filter.value.anomaly) {
				return strAnomaly;
			} else {
				return strInfo;
			}
		},
		setDiagnosticData(currentData, currentFromDate, currentEndDate, previousData, previousFromDate, previousEndDate) {
			var self = this;

			self.diagnosticChartTitle = `Confronto conteggio ${this.getTypeOfElementsString()} dal ${previousFromDate} al ${currentEndDate}`;
			let reportName = "Conteggio_diagnosi";
			if (this.reportName) {
				reportName = this.reportName.replace(/[ ]/g, "_");
			}
			self.diagnosticChartPdfOptions.fileName = helpers.chartPdffileName(this, reportName, moment(previousFromDate, "DD/MM/YYYY"), moment(currentEndDate, "DD/MM/YYYY"));
			self.diagnosticChartData = [];
			self.diagnosticChartCategoryAxis.categories = [];

			for (var i = 0; i < previousData.length; i++) {
				var category = previousData[i].category;
				var displayedCategory = previousData[i].display_category.toUpperCase();
				var inserted =
					self.diagnosticChartCategoryAxis.categories.findIndex(item => {
						return item.toLowerCase() == displayedCategory.toLowerCase();
					}) >= 0;

				if (inserted == false) {
					self.diagnosticChartCategoryAxis.categories.push(displayedCategory);
				}

				self.diagnosticChartData.push({
					from: currentFromDate,
					to: currentEndDate,
					previousfrom: previousFromDate,
					previousto: previousEndDate,
					name: category,
					current: 0,
					previous: previousData[i].count
				});
			}

			for (var i = 0; i < currentData.length; i++) {
				var category = currentData[i].category;
				var displayedCategory = currentData[i].display_category;
				var inserted =
					self.diagnosticChartCategoryAxis.categories.findIndex(item => {
						return item.toLowerCase() == displayedCategory.toLowerCase();
					}) >= 0;

				if (inserted == false) {
					self.diagnosticChartCategoryAxis.categories.push(displayedCategory);
				}

				var previousItem = self.diagnosticChartData.find(item => {
					return item.name == category;
				});

				if (previousItem) {
					previousItem.current = currentData[i].count;
				} else {
					self.diagnosticChartData.push({
						from: currentFromDate,
						to: currentEndDate,
						previousfrom: previousFromDate,
						previousto: previousEndDate,
						name: category,
						current: currentData[i].count,
						previous: 0
					});
				}
			}

			self.diagnosticChartIndex++;
		},
		getRequestData() {
			var self = this;
			var data = {};

			var types = ["anomaly_event"];
			data.types = types;

			if (this.filters && this.filters.length > 0) {
				this.filters.forEach(element => {
					switch (element.id) {
						case "timerange":
							data["dateRange.From"] = moment(element.value.startRange)
								.utc()
								.format();
							data["dateRange.To"] = moment(element.value.endRange)
								.utc()
								.format();
							break;
						case "divisions":
							if (element.value) {
								data["division"] = element.value;
							}
							break;
						case "groups":
							if (element.value && element.value != -1) {
								data["group"] = element.value;
							}
							break;
						case "vehicles":
							if (element.value && element.value.length > 0) {
								for (var j = 0; j < element.value.length; j++) {
									var field = `${self.vehicleIdFilterFieldFormatted}[${j}]`;
									var value = element.value[j];

									data[field] = value;
								}
							}
							break;
						case "drivers":
							if (element.value) {
								data["driver"] = element.value;
							}
							break;
						case "diagnosis-type":
							var types = [];
							if (element.value.anomaly) types.push("anomaly_event");
							if (element.value.information) types.push("info_event");
							if (element.value.information == false && element.value.anomaly == false) {
								types.push("anomaly_event");
								types.push("info_event");
							}

							if (types.length > 0) {
								data["types"] = types;
							}
							break;
						default:
							break;
					}
				});
			}

			return data;
		},

		//Modal
		exportAsXlsx(type) {
			var self = this;

			var data = this.getRequestData();
			if (type == "csv") data["format"] = "csv";
			ApiService.exportChartXlsx("diagnosis/chart", data).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `diagnostica.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},

		exportAsPdf() {
			var container = $("<div />")
				.css({
					position: "absolute",
					top: 0,
					left: -1500,
					height: 600
				})
				.appendTo("body");

			function cleanup() {
				container.getKendoChart().destroy();
				container.remove();
			}

			this.createChart(container, {
				transitions: false,

				render: function(e) {
					e.sender.saveAsPDF();
					setTimeout(cleanup, 500);
				}
			});
		},
		createChart(container, exportOptions) {
			var self = this;

			var options = {
				chartArea: {
					height: 700
				},
				pdf: self.diagnosticChartPdfOptions,
				theme: "metro",
				title: {
					text: self.diagnosticChartTitle.toUpperCase(),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					position: "bottom",
					item: {
						visual: function(e) {
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var color = e.series.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				series: [
					{
						name: "Periodo precedente",
						field: "previous",
						color: "#ffdf00",
						labels: {
							visible: true,
							template: this.getStackTimeFromString,
							background: "none",
							font: "13px montserrat-light"
						}
					},
					{
						name: "Periodo attuale",
						field: "current",
						color: "#ff8300",
						labels: {
							visible: true,
							template: this.getStackTimeFromString,
							background: "none",
							font: "13px montserrat-light"
						}
					}
				],
				dataSource: {
					data: self.diagnosticChartData
				},
				valueAxis: self.diagnosticChartValueAxisModal,
				categoryAxis: {
					categories: self.diagnosticChartCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			options = $.extend(true, options, exportOptions);
			$(container).kendoChart(options);
		}
	},
	computed: {
		...mapGetters(["settings"])
	}
};
